// plugins/scrollPosition.ts

export default defineNuxtPlugin((nuxtApp) => {
  // Store for scroll positions
  const scrollPositions: Record<string, number> = {}
  let isNavigating = false
  
  // Add scrollPositions to the nuxtApp
  // @ts-ignore - Adding custom property
  nuxtApp.$scrollPositions = scrollPositions
  
  // Helper function to get the full path safely
  const getFullPath = (route: any): string => {
    if (route && route.fullPath) {
      return route.fullPath;
    }
    
    // Fallback: construct fullPath from path and query
    if (route && route.path) {
      const query = route.query || {};
      const queryString = Object.keys(query).length 
        ? '?' + new URLSearchParams(query as Record<string, string>).toString() 
        : '';
      return route.path + queryString;
    }
    
    // Last resort fallback
    return route?.path || '/';
  };
  
  // Save scroll position before navigation
  // @ts-ignore - Hook type mismatch
  nuxtApp.hook('page:start', () => {
    // Disabled scroll position saving
    return;
  });
  
  // Handle navigation start
  // @ts-ignore - Hook type mismatch
  nuxtApp.hook('navigate:start', () => {
    // Disabled navigation tracking
    return;
  });
  
  // Handle navigation end
  // @ts-ignore - Hook type mismatch
  nuxtApp.hook('navigate:end', () => {
    // Disabled navigation tracking
    return;
  });
  
  // Clear scroll position after navigation
  // @ts-ignore - Hook type mismatch
  nuxtApp.hook('page:finish', () => {
    // Disabled scroll position restoration
    return;
  });
});
